import axios from 'axios';
import authHeader from "@/service/auth-header";

class BillingRunService {

    async getCompanyBillingRuns(companyId) {
        return await axios.get(`/api/billingrun/${companyId}`, {headers: authHeader()})
    }

    async createBillingRun(companyId, data) {
        return await axios.post(`/api/billingrun/${companyId}`, data, {headers: authHeader()});
    }

    async updateBillingRun(billingRunId, data) {
        return await axios.put(`/api/billingrun/${billingRunId}`, data, {headers: authHeader()});
    }

    async deleteBillingRun(billingRunId) {
        return await axios.delete(`/api/billingrun/${billingRunId}`,{ headers: authHeader() })
    }

}

export default new BillingRunService();
